import React from 'react';

const LevelUp = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.67 14H4C2.9 14 2 14.9 2 16V21C2 21.55 2.45 22 3 22H6.67C7.22 22 7.67 21.55 7.67 21V15C7.67 14.45 7.22 14 6.67 14Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.3263 10H10.6562C9.55625 10 8.65625 10.9 8.65625 12V21C8.65625 21.55 9.10625 22 9.65625 22H14.3263C14.8763 22 15.3263 21.55 15.3263 21V12C15.3263 10.9 14.4363 10 13.3263 10Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.9981 17H17.3281C16.7781 17 16.3281 17.45 16.3281 18V21C16.3281 21.55 16.7781 22 17.3281 22H20.9981C21.5481 22 21.9981 21.55 21.9981 21V19C21.9981 17.9 21.0981 17 19.9981 17Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.0095 4.85001C15.3195 4.54001 15.4395 4.17001 15.3395 3.85001C15.2395 3.53001 14.9295 3.30001 14.4895 3.23001L13.5295 3.07001C13.4895 3.07001 13.3995 3.00001 13.3795 2.96001L12.8495 1.90001C12.4495 1.09001 11.5395 1.09001 11.1395 1.90001L10.6095 2.96001C10.5995 3.00001 10.5095 3.07001 10.4695 3.07001L9.50945 3.23001C9.06945 3.30001 8.76945 3.53001 8.65945 3.85001C8.55945 4.17001 8.67945 4.54001 8.98945 4.85001L9.72945 5.60001C9.76945 5.63001 9.79945 5.75001 9.78945 5.79001L9.57945 6.71001C9.41945 7.40001 9.67945 7.71001 9.84945 7.83001C10.0195 7.95001 10.3895 8.11001 10.9995 7.75001L11.8995 7.22001C11.9395 7.19001 12.0695 7.19001 12.1095 7.22001L12.9995 7.75001C13.2795 7.92001 13.5095 7.97001 13.6895 7.97001C13.8995 7.97001 14.0495 7.89001 14.1395 7.83001C14.3095 7.71001 14.5695 7.40001 14.4095 6.71001L14.1995 5.79001C14.1895 5.74001 14.2195 5.63001 14.2595 5.60001L15.0095 4.85001Z",
      fill: "white"
    }
  )
);
LevelUp.displayName = "Icons.LevelUp";

export { LevelUp };
//# sourceMappingURL=LevelUp.js.map
